import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Account } from '../shared/model/Account';
import { AdminContactService } from '../shared/service/admin-contact.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
declare var $: any;
const LOCAL_USER_KEY = "UserName";


@Component({
  selector: 'app-admin-contact-account',
  templateUrl: './admin-contact-account.component.html',
  styleUrls: ['./admin-contact-account.component.css']
})
export class AdminContactAccountComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  accountArr = [];
  dataSource: any;
  LocalToken: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['AccountName', 'BankName', 'AccountNo', 'IFSCCode', 'Edit', 'Delete'];

  constructor(private adminContactService: AdminContactService, private router: Router, private dialog: MatDialog) { }

  ngOnInit() {
    this.LocalToken = localStorage.getItem(LOCAL_USER_KEY);
    if (this.LocalToken != null) {
      this.getAccountDetails();
    }
    else {
      this.router.navigate(["admin/logIn"]);
    }

  }

  getAccountDetails() {
    this.adminContactService
      .getAccountDetails()
      .then((result) => {
        this.accountArr = result;
        this.dataSource = new MatTableDataSource(this.accountArr);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
      .catch((err) => console.log(err));
  }



  openAccountDialog() {
    const dialogRef = this.dialog.open(AdminContactAccountDialog, {
      width: '1000px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAccountDetails();
    });
  }

  editAccountDialog(accountObj) {
    const dialogRef = this.dialog.open(AdminContactAccountDialog, {
      width: '1000px',
      data: accountObj
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getAccountDetails();
    });
  }


  deleteAccountDetails(ID) {
    if (this.accountArr.length > 1) {
      if (confirm('Are you sure you want selected item deleted !')) {
        this.adminContactService
          .deleteAccountDetailsByID(ID)
          .then((result) => this.getAccountDetails())
          .catch((err) => console.log(err));
      }
    }
  }

  applyAccountFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}


// Franchises Dialoag Component

@Component({
  selector: 'admin-contact-account-dialog',
  templateUrl: 'admin-contact-account-dialog.html',
})

export class AdminContactAccountDialog {
  @BlockUI() blockUI: NgBlockUI;
  isUpdate: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<AdminContactAccountDialog>,
    @Inject(MAT_DIALOG_DATA) public data: Account, private adminContactService: AdminContactService) {
    if (this.data.Id) {
      this.isUpdate = true;
    }
  }

  addAccountDetails() {
    this.blockUI.start('Please wait...');
    this.adminContactService
      .addAccountDetails(this.data)
      .then((result) => {
        this.dialogRef.close();
        this.clearControl();
        this.blockUI.stop();
      })
      .catch((err) => this.errorHandler(err));
  }
  editAccountDetails() {
    this.blockUI.start('Please wait...');
    this.adminContactService
      .editAccountDetails(this.data)
      .then((result) => {
        this.dialogRef.close();
        this.clearControl();
        this.isUpdate = false;
        this.blockUI.stop();
      })
      .catch((err) => this.errorHandler(err));
  }


  isInputNumber(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode === 8 || event.keyCode === 46) {
      return true;
    } else if (key < 48 || key > 57) {
      return false;
    } else {
      return true;
    }
  }


  clearControl() {
    this.data;
  }

  errorHandler(err: any) {
    console.log(err);
    this.blockUI.stop();
  }
}
